import { render, staticRenderFns } from "./SampleSets.vue?vue&type=template&id=dec203cc&scoped=true&"
import script from "./SampleSets.vue?vue&type=script&lang=js&"
export * from "./SampleSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec203cc",
  null
  
)

export default component.exports